
















































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import PAPER_OPTIONS from '@/config/paper_config'
import uploadImg from './uploadImg.vue'
const editInputProp = ['certTypeName', 'name', 'issuingAuthority', 'beginDate', 'endDate', 'paperUpload', 'paperAction']
@Component({
	components: {
		uploadImg
	}
})
export default class PaperDialogDetails extends Vue {
	@Prop ({
		type: Boolean,
		required: true,
		default: ''
	}) private paperDialogTableVisible!: boolean
	private options: any = PAPER_OPTIONS
	private tableData: any = []
	private numbers: number = 1
	private uploadFile: any = []
	private created () {
		this.getPaper()
	}
	private getPaper () {
		return (this as any).$fxHttp.requestPost({
			url: '/sysCert/getSysCertListByOrganId'
		}).then((res: any) => {
			res.map((e) => {
				e.beginDate = e.beginDate.substring(0, e.beginDate.indexOf(' '))
				e.endDate = e.endDate.substring(0, e.endDate.indexOf(' '))
			})
			this.tableData = res
			return Promise.resolve()
		})
	}
	private onTableRowClick (item: any, colum: any, cell: any, event: any) {
		let property = colum.property
		if (!editInputProp.includes(property)) {
			property = editInputProp[0]
		}
		this.hintInfo().then(() => {
			this.setTableUnEdit().then(() => {
				item.isEdit = true
				this.$nextTick(() => {
					// (this.$refs[`grid-${property}`] as any).focus()
				})
			})
		})
	}
	private onCellInputEnter (arg: any, prop: string, index: number) {
		if (prop === 'next') {
			if (index === this.tableData.length - 1) {
				this.onSaveClick()
				return false
			}
			const row = this.tableData[index + 1]
			this.setTableUnEdit().then(() => {
				this.setTableEdit(row, index + 1)
			})
		} else {
			(this.$refs[`grid-${prop}`] as any).focus()
		}
	}
	private setTableEdit (row: any, index: number) {
		(this as any).$set(this.tableData[index], 'isEdit', true)
		this.$nextTick(() => {
			(this.$refs[`grid-${editInputProp[0]}`] as any).focus()
		})
	}
	private setTableUnEdit () {
		this.tableData.forEach((item: any, index: number) => {
			(this as any).$set(this.tableData[index], 'isEdit', false)
		})
		return Promise.resolve()
	}
	private onCellInputDown (arg: any, prop: string, index: number) {
		if (index === this.tableData.length - 1) {
			return false
		}
		const row = this.tableData[index + 1]
		this.setTableUnEdit().then(() => {
			(this as any).$set(this.tableData[index + 1], 'isEdit', true)
			this.$nextTick(() => {
				(this.$refs[`grid-${prop}`] as any).focus()
			})
		})
	}
	private onCellInputUp (arg: any, prop: string, index: number) {
		if (index === 0) {
			return false
		}
		this.setTableUnEdit().then(() => {
			(this as any).$set(this.tableData[index - 1], 'isEdit', true)
			this.$nextTick(() => {
				(this.$refs[`grid-${prop}`] as any).focus()
			})
		})
	}
	private isEdit () {
		const editArr = this.tableData.map((item: any) => {
			return item.isEdit
		})
		return editArr.some((item: any) => {
			return !!item
		})
	}
	private selectOptions (detailData: any, val: any) {
		const certType = this.options.filter((e) => {
			return e.value === val
		})
		detailData.certTypeId = certType[0].value
		detailData.certTypeName = certType[0].label
	}
	private submitCheckInput (detailData: any) {
		return new Promise ((resolve: any, reject: any) => {
			detailData[0].name = detailData[0].name.replace(/^\s+|\s+$/g, '')
			detailData[0].issuingAuthority = detailData[0].issuingAuthority.replace(/^\s+|\s+$/g, '')
			if (!detailData[0].name) {
				this.$message.error('证照名称不能为空')
				reject()
			} else if (!detailData[0].issuingAuthority) {
				this.$message.error('发证机关不能为空')
				reject()
			} else if (!detailData[0].beginDate) {
				this.$message.error('生效日期不能为空')
				reject()
			} else if (!detailData[0].endDate) {
				this.$message.error('失效日期不能为空')
				reject()
			} else if (detailData[0].endDate < detailData[0].beginDate) {
				this.$message.error('失效日期不能小于生效日期')
				reject()
			} else if (!detailData[0].certObj[0].path) {
				this.$message.error('请选择要上传的证照')
				reject()
			} else {
				resolve()
			}
		})
	}
	private onSaveClick () {
		return new Promise ((reslove: any) => {
			if (!this.isEdit()) {
				return false
			}
			const details	= this.tableData.filter((e: any) => {
				return e.isEdit === true
			})
			this.submitCheckInput(details).then(() => {
				this.onSaveHandler(details).then(() => {
					this.getPaper()
					this.setTableUnEdit()
					this.$message.success('保存成功')
					reslove()
				})
			})
		})
	}
	private onSaveHandler (details: any) {
		const url = details[0].id ? 'update' : 'upload'
		const params = new FormData()
		if (details[0].id) {
			params.append('id', details[0].id)
		}
		params.append('name', details[0].name)
		params.append('certTypeId', details[0].certTypeId)
		params.append('certTypeName', details[0].certTypeName)
		params.append('issuingAuthority', details[0].issuingAuthority)
		params.append('beginDate', details[0].beginDate + ' 00:00:00')
		params.append('endDate', details[0].endDate + ' 00:00:00')
		params.append('file', this.uploadFile)
		return (this as any).$fxHttp.requestPost({
			url: '/sysCert/certificates/' + url,
			data: params
		}).then((res: any) => {
			return Promise.resolve()
		})
	}
	private addRow () {
		this.hintInfo().then(() => {
			this.tableData.push({
				isEdit: true,
				certTypeId: '01',
				certTypeName: '营业执照',
				name: '',
				issuingAuthority: '',
				beginDate: '',
				endDate: '',
				certObj: [{
					id: '',
					path: ''
				}]
			})
		})
	}
	private hintInfo () {
		return new Promise ((resolve: any, reject: any) => {
			const details	= this.tableData.filter((e: any) => {
				return e.isEdit === true
			})
			if (details.length > 0) {
				(this as any).$fxMessage.warning('请保存或删除正在编辑的证照')
				reject()
			}
			resolve()
		})
	}
	private onClose () {
		const details	= this.tableData.filter((e: any) => {
			return e.isEdit === true
		})
		this.submitCheckInput(details).then(() => {
			this.$emit('update:paperDialogTableVisible', false)
			this.getPaper()
		}).catch(() => {
			this.hintInfo().then(() => {
				this.$emit('update:paperDialogTableVisible', false)
			})
		})
	}
	private beforeDeleteClick (index: any, row: any) {
		(this as any).$fxConfirm('确定要删除这条证照吗？').then(() => {
			if (row.id) {
				(this as any).handleDelete(index, row)
			} else {
				this.getPaper().then(() => {
					(this as any).$fxMessage.success('删除成功')
				})
			}
		})
	}
	private handleDelete (index: any, row: any) {
		const params = {
			id: row.id
		}
		return new Promise ((resolve: any) => {
			return (this as any).$fxHttp.requestPost({
				url: '/sysCert/certificates/delete',
				data: params
			}).then((res: any) => {
				(this as any).getPaper()
				resolve()
			})
		})
	}
	private onImgUpload (file: any) {
		const details	= this.tableData.filter((e: any) => {
			return e.isEdit === true
		}).map((e: any) => {
			e.certObj[0].path = file.event.target.result
		})
		this.uploadFile = file.uploadFile
	}
}
